<div class="tooltip-container m-h-50 relative">
  <app-loader [enable]="!(initBackLoaded$ | async)">
    <div class="mb-10" *ngFor="let component of tooltip">
      <ng-container *ngComponentOutlet="component; injector: injector"></ng-container>
    </div>
  </app-loader>
</div>
